import {ValueAndLabelModel} from '../../../common/model/valueAndLabel.model';

export class JwtSubscriptionModel {
    providerBusinessCode: string;
    service: ValueAndLabelModel;
    isDefault = false;

}
